module.exports = __webpack_public_path__ + "static/media/ios-water.81decf06.svg";